<template>
	<div>
		<component :commandResponse="commandResponse" :is="currentOptionsComponent"></component>

		<button-save @click="saveOptions"></button-save>
	</div>
</template>

<script>
	import NoOptionsComponent from './Options/NoOptions'
	import APIOptionComponent from './Options/API'
	import DataSetOptionComponent from './Options/DataSet'
	import DataSourceOptionComponent from './Options/DataSource'
	import ComponentOptionComponent from './Options/Component'
	import MenuOptionComponent from './Options/Menu'
	import ShopingCartOptionComponent from './Options/ShopingCart'

	import ButtonSave from '@/components/ButtonSave'

	import axios from 'axios'

	/**
	 * @group CommandResponse
	 *
	 * Command Response Options
	 *
	 */
	export default {
		name: 'CommandResponseOptions',

		components: {
			/**
			 * @vuese
			 *
			 * Save Button Component
			 */
			ButtonSave,
		},
		computed: {
			/**
			 * @vuese
			 *
			 * Get service ID from route path
			 *
			 * @type `Number`
			 *
			 */
			serviceId() {
				return this.$route.params.service_id
			},
			/**
			 * @vuese
			 *
			 * Get command ID from route path
			 *
			 * @type  `Number`
			 */
			commandId() {
				return this.$route.params.command_id
			},
			/**
			 * @vuese
			 *
			 * Get command response ID from route path
			 *
			 * @type  `Number`
			 */
			commandResponseId() {
				return this.$route.params.command_id
			},
		},
		data() {
			return {
				currentOptionsComponent: null,
				ButtonSave: ButtonSave,
				commandResponse: {
					resp_dataset: {}
				},
				service_id: null,
				command_id: null,
			}
		},

		methods: {
			/** @vuese
			 *
			 * Get response options based on its type
			 *
			 * @api {api/command-response/{commandId}/options}
			 *
			 * @return {void}
			 */
			async getCommandResponse() {
				try {
					const {data} = await axios.get(`command-response/${this.commandId}/options`);
					if (data.commandResponse) {
						this.commandResponse = data.commandResponse;
						this.selectOptionsComponent();
					}
				} catch (error) {
					console.error(error);
				}
			},

			/**
			 * @vuese
			 *
			 * Save Options
			 * 
			 * Deprecated
			 *
			 * @return  {void}
			 */
			async saveOptionsOld() {
				try {
					await axios.post(`command-response/${this.commandId}/options`, this.commandResponse)
				} catch (error) {
					console.error(error)
				}
			},

			/**
			 * @vuese
			 *
			 * Save Options
			 *
			 * @return  {void}
			 */
			saveOptions() {
				this.$store.commit('setResponseDataProperty', this.commandResponse)
				
				this.$router.push(`/services/${this.service_id}/commands/${this.command_id}/result/template`)
			},

			/**
			 * @vuese
			 *
			 * Determine which component should be rendered
			 *
			 * based on response type
			 *
			 * @return  {void}
			 */
			selectOptionsComponent() {
				switch (this.commandResponse.resp_type.toUpperCase()) {
					case 'TEXT':
						this.currentOptionsComponent = NoOptionsComponent
						break
					case 'STATIC_CARDS':
						this.currentOptionsComponent = NoOptionsComponent
						break
					case 'API':
						this.currentOptionsComponent = APIOptionComponent
						break
					case 'DATASET':
						this.currentOptionsComponent = DataSetOptionComponent
						break
					case 'DATASOURCE':
						this.currentOptionsComponent = DataSourceOptionComponent
						break
					case 'SHOPPING_CART':
						this.currentOptionsComponent = ShopingCartOptionComponent
						break
					case 'COMPONENT':
						this.currentOptionsComponent = ComponentOptionComponent
						break
					case 'MENU':
						this.currentOptionsComponent = MenuOptionComponent
						break
					default:
						break
				}
			},
		},

		created() {
			this.getCommandResponse()
			this.service_id = this.$route.params.service_id;
			this.command_id = this.$route.params.command_id;
		},
	}
</script>
